import Axios from "axios";
import CONFIG from "../../model/TSConfig";
import { HEADER_TOKEN } from "../../utils/constants";
import SaaSPromoCode from "@tootsweet/model/entities/saas/SaaSPromoCode";

export interface ComputePricesResponse {
  currentSubPrice?: number;
  currentSub?: string;

  nextSubPriceExclVAT: number;
  nextSubPriceVAT: number;
  nextSubPriceInclVAT: number;

  nextSub?: string;

  upsellExclVAT: number;
  upsellVAT: number;
  upsellInclVAT: number;

  nextSubPriceBeforeDiscount: number;
  discountPcBase100?: number;

  currency?: string;
}

export async function fetchPrices(
  token: string,
  saasPlanId: string,
  saasCommitment: string,
  promoCode?: string | null,
  promoCode2?: string | null
): Promise<ComputePricesResponse> {
  const res = await Axios({
    method: "GET",
    url: `${CONFIG.backendURL}/saas/compute_price`,
    params: { saasPlanId, saasCommitment, promoCode, promoCode2 },
    headers: {
      [HEADER_TOKEN]: token
    }
  });

  return res.data;
}

export async function fetchPromoCode(
  businessUserId: string,
  promoCode: string,
  planId: string,
  token: string
): Promise<SaaSPromoCode> {
  const res = await Axios({
    method: "GET",
    url: `${CONFIG.saasBackendUrl}/subscription/promo-code`,
    params: {
      businessUserId,
      promoCode,
      planId
    },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return res.data;
}
